import { render, staticRenderFns } from "./infoCharacteristic.vue?vue&type=template&id=32e62885&scoped=true&"
import script from "./infoCharacteristic.vue?vue&type=script&lang=js&"
export * from "./infoCharacteristic.vue?vue&type=script&lang=js&"
import style0 from "./infoCharacteristic.vue?vue&type=style&index=0&id=32e62885&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e62885",
  null
  
)

export default component.exports